module.exports = __webpack_public_path__ + "img/lottba2.665a3754.png";